import dayjs from 'dayjs';
import { ADULT_RATING_AGE, NOT_ADULT_RATING_AGE } from './adult-rating-age';

const getSubscriberAge = (dateOfBirth) => dayjs().diff(dayjs(dateOfBirth), 'year');

const isAdult = (dateOfBirth) => {
  if (!dateOfBirth) {
    return;
  }

  return getSubscriberAge(dateOfBirth) >= ADULT_RATING_AGE;
};

const isUnderage = (dateOfBirth) => {
  if (!dateOfBirth) {
    return;
  }

  return getSubscriberAge(dateOfBirth) <= ADULT_RATING_AGE;
};

const getSubscriberRating = (dateOfBirth) => {
  if (!dateOfBirth) {
    return;
  }
  return isAdult(dateOfBirth) ? ADULT_RATING_AGE : NOT_ADULT_RATING_AGE;
};

export { getSubscriberRating, isUnderage, isAdult };
